function randomFromInterval(min, max) {
  return Math.random() * (max - min) + min;
}

function cubicBezier(P0, P1, P2, P3, t) {
  var x = (1 - t) ** 3 * P0[0] + 3 * (1 - t) ** 2 * t * P1[0] + 3 * (1 - t) * t ** 2 * P2[0] + t ** 3 * P3[0];
  var y = (1 - t) ** 3 * P0[1] + 3 * (1 - t) ** 2 * t * P1[1] + 3 * (1 - t) * t ** 2 * P2[1] + t ** 3 * P3[1];
  return [x, y];
}

// Generate cat ear with continuous parameters (large triangular, pointy - cartoon style)
function generateCatEar(startPoint, isLeft = false) {
  let direction = isLeft ? -1 : 1;

  // All continuous random parameters (larger for cartoon cats)
  let earWidth = randomFromInterval(30, 55);  // Wider base
  let earHeight = randomFromInterval(45, 75); // Taller

  // Ear tilt: cartoon cats have ears pointing outward
  let earTilt = randomFromInterval(0.2, 0.5);

  // Ear pointiness: cartoon cats have sharp pointed ears
  let pointiness = randomFromInterval(0.02, 0.12);

  let earPoints = [];
  earPoints.push(startPoint);

  // Calculate tip position - pointing up and outward
  let tipX = startPoint[0] + direction * earWidth * earTilt;
  let tipY = startPoint[1] - earHeight;

  // Outer edge going to tip (straighter for cartoon triangular ears)
  for (let t = 0; t <= 1; t += 0.05) {
    let point = cubicBezier(
      startPoint,
      [startPoint[0] + direction * earWidth * 0.7, startPoint[1] - earHeight * 0.2],
      [startPoint[0] + direction * earWidth * (0.6 + earTilt * 0.5), startPoint[1] - earHeight * 0.75],
      [tipX, tipY],
      t
    );
    earPoints.push(point);
  }

  // Inner edge back to head (straighter for cartoon style)
  for (let t = 0; t <= 1; t += 0.05) {
    let point = cubicBezier(
      [tipX, tipY],
      [startPoint[0] + direction * earWidth * pointiness, startPoint[1] - earHeight * 0.75],
      [startPoint[0] - direction * earWidth * 0.1, startPoint[1] - earHeight * 0.25],
      startPoint,
      t
    );
    earPoints.push(point);
  }

  return earPoints;
}

export function generateBothCatEars(leftEarPoint, rightEarPoint, headWidth, headHeight) {
  // Each ear is independently generated with random continuous parameters
  let leftEar = generateCatEar(leftEarPoint, true);
  let rightEar = generateCatEar(rightEarPoint, false);

  return { left: leftEar, right: rightEar };
}
